import { Divider, Stack } from "@mantine/core";
import { StepIndicator } from "../../../ui/StepIndicator/StepIndicator";
import CustomModal from "../../../ui/CustomModal/CustomModal";
import BankAccountStep1 from "./BankAccountStep1";
import BankAccountStep2 from "./BankAccountStep2";

const STEPS = [{ label: "Verify Account" }, { label: "Add Account" }];

const AddBankAccountModal = ({
  opened,
  onClose,
  currentStep,
  step1Draft,
  verifiedData,
  isVerifying,
  isSaving,
  goToStep2,
  goBackToStep1,
  handleSave,
  setStep1Draft,
  verifyBankAccount,
  verifyViaMsisdn,
}) => {
  const isBusy = isVerifying || isSaving;
  const handleClose = () => {
    if (!isBusy) onClose();
  };

  return (
    <CustomModal
      opened={opened}
      onClose={handleClose}
      closeOnClickOutside={!isBusy}
      closeOnEscape={!isBusy}
      size="lg"
      title={
        <div>
          <h2 className="text-base sm:text-lg font-semibold text-gray-900">
            Add Bank Account
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
            {currentStep === 1
              ? "Search and verify your bank account details"
              : "Review your verified account before saving"}
          </p>
        </div>
      }
      centered
      radius="lg"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      styles={{ body: { padding: 0 } }}
    >
      <div
        style={{
          minHeight: "400px",
          maxHeight: "calc(90dvh - 170px)",
          overflowY: "auto",
          padding: "0 1rem 1rem",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack gap="md" style={{ flex: 1 }}>
          <Divider />
          <StepIndicator
            steps={STEPS}
            currentStep={currentStep}
            layout="horizontal"
          />

          <Divider />

          {currentStep === 1 && (
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <BankAccountStep1
                step1Draft={step1Draft}
                setStep1Draft={setStep1Draft}
                verifyBankAccount={verifyBankAccount}
                verifyViaMsisdn={verifyViaMsisdn}
                isVerifying={isVerifying}
                goToStep2={goToStep2}
                onClose={handleClose}
              />
            </div>
          )}

          {currentStep === 2 && (
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <BankAccountStep2
                verifiedData={verifiedData}
                handleSave={handleSave}
                isSaving={isSaving}
                goBackToStep1={goBackToStep1}
              />
            </div>
          )}
        </Stack>
      </div>
    </CustomModal>
  );
};

export default AddBankAccountModal;
